<template lang="pug">
.btnToolbar
  .editBox__icon
    .fontSize
      i.fa.fa-text-height.fa-fw
  .boxtamanyoletra
    i.fa.fa-minus(@click="decrementFontSize()")
    i.fa.fa-plus(@click="incrementFontSize()")
</template>

<script>
import { mapMutations } from 'vuex'

export default {
  name: 'documents-font-size-button-vue',
  methods: {
    ...mapMutations([
      'incrementFontSize',
      'decrementFontSize'
    ])
  }
}
</script>
